import React from "react";

// material components
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import Paper from "@material-ui/core/Paper";

// custom components
import withShipment from "../../withShipment";
import CustomToolbar from "../global/CustomToolbar";

// constants
import {
    BACK_TO_MENU,
    DEFAULT_ROWS_PER_PAGE,CREATE_ORDER_PLANNING_TITLE, ORDER_PLANNING_TITLE,
} from './constants';

import { listAvailableLocations, listPackages, listProducts, listSuppliers } from '../../redux/actions/settings';
import {
  availableLocationsSelector,
  packagesSelector,
  productsSelector,
  suppliersSelector as realSuppliersSelector,
} from '../../redux/selectors/settings';
import {selectedLocationIdSelector, userInfoSelector} from "../../redux/selectors/auth";
import ErrorFeedbackBar from "../global/ErrorFeedbackBar";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import OrderPlanningForm from './OrderPlanningForm';
import OrderPlanningTable from './OrderPlanningTable';
import {
  getInventorySummaryForFTL, listAllBoxInventory,
  listAllProductInventory,
  listManufacturers,
} from '../../redux/actions/inventory';
import {
  boxesInventorySelector, inventorySummaryColumForFTLSelector,
  manufacturersSelector,
  productsInventorySelector,
} from '../../redux/selectors/inventory';
import {
  listAllOpenAndPartialPurchaseOrders,
} from '../../redux/actions/purchaseOrders';

import {
  automatePurchaseOrder,
  deleteOrderPlanning,
  listOrderPlanning, listShippedFTLs, refreshNewPurchaseOrder, removePurchaseOrder,
  saveOrderPlanning,
} from '../../redux/actions/orderPlanning';
import {
  allOrderPlanningSelector, allShippedFTLSelector,
} from '../../redux/selectors/orderPlanning';
import { saveFTLDraft, saveFullTruckload } from '../../redux/actions/fullTruckload';
import { allOpenAndPartialPurchaseOrdersSelector } from '../../redux/selectors/purchaseOrders';


class OrderPlanning extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            rowsPerPage: DEFAULT_ROWS_PER_PAGE,
            creatingOrderPlanning: false,
            orderPlanningOpened: null,
            searchText: '',
            fromLocation: null,
            filteredPackages: [],
            filteredProducts:[]

        }
    }

    componentDidMount() {
       this.props.listAvailableLocations()
       this.props.listManufacturers();
       this.props.listProducts()
       this.props.listPackages()
       this.props.listSuppliers();
       this.props.listAllOpenAndPartialPurchaseOrders()
       this.props.listShippedFTLs()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.availableLocations !== this.props.availableLocations) {
                    let findLocation = this.props.availableLocations.find((location) => location.shipAddressId === this.props.selectedLocation)
                    let defaultLocation = findLocation ? findLocation : {}

                    this.setState({
                        fromLocation: defaultLocation
                    },()=>{
                      const data = {
                            locationId: defaultLocation?.shipAddressId
                     }
                     this.props.listAllProductInventory(data)
                     this.props.listAllBoxInventory(data)
                     this.props.listOrderPlanning(data)
                    })
        }

          if (prevProps.selectedLocation !== this.props.selectedLocation) {
                    let findLocation = this.props.availableLocations.find((location) => location.shipAddressId === this.props.selectedLocation)
                    let defaultLocation = findLocation ? findLocation : {}

                    this.setState({
                        fromLocation: defaultLocation
                    },()=>{
                        const data = {
                            locationId: defaultLocation?.shipAddressId
                     }
                     this.props.listAllProductInventory(data)
                     this.props.listAllBoxInventory(data)
                     this.props.listOrderPlanning(data)
                    })
        }


          if (prevProps.packages !== this.props.packages && this.props.packages !== null) {
            const packages = this.props.packages.filter(curPackage =>curPackage.locations.length > 0)
            this.setState({
                filteredPackages: packages
            })
        }

        // filter out products with no location enabled
        if (prevProps.products !== this.props.products && this.props.products !== null) {
            const products = this.props.products.filter(curProduct => curProduct.locations.length > 0)
            this.setState({
                filteredProducts: products
            })
        }


    }


    setPage = (page) => {
        this.setState({
            page: page
        })
    }

    setRowsPerPage = (rowsPerPage) => {
        this.setState({
            rowsPerPage: rowsPerPage
        })
    }

    creatingOrderPlanning = () => {
        this.setState({
            creatingOrderPlanning: true
        })
    }

    cancelOrderPlanning = () => {
        this.setState({
            creatingOrderPlanning: false,
            orderPlanningOpened: null,
        })
    }


    openOrderPlanning= (orderPlanning) => {
        this.setState({
            orderPlanningOpened: orderPlanning
        })
    }

    handleSearchTextChange = (e) => {
        this.setState({
            searchText: e.target.value
        })
    }

    render() {
        let headerButtons = []

        if (!this.state.orderPlanningOpened && !this.state.creatingOrderPlanning) {
            headerButtons = [
                { icon: <AddCircleIcon />, handler: this.creatingOrderPlanning, title: "Create Order Planning" },
            ]
        }

        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <ErrorFeedbackBar />
                <Paper className='paper'>
                    {!(this.state.creatingOrderPlanning || this.state.orderPlanningOpened) &&
                      <CustomToolbar
                        title={ORDER_PLANNING_TITLE}
                        createTitle={CREATE_ORDER_PLANNING_TITLE}
                        backTitle={BACK_TO_MENU}
                        onClick={this.creatingOrderPlanning}
                        handleClose={this.cancelOrderPlanning}
                        headerButtons={headerButtons}
                      />
                    }

                    {!this.state.orderPlanningOpened ?
                        this.state.creatingOrderPlanning ?
                            <OrderPlanningForm
                                cancel={this.cancelOrderPlanning}
                                creatingForm={true}
                                returnItem={null}
                                fromLocation={this.state.fromLocation}
                                availableLocations={this.props.availableLocations}
                                manufacturers={this.props.manufacturers}
                                productInventory={this.props.productsInventory}
                                boxesInventory={this.props.boxesInventory}
                                openAndPartialPurchaseOrders={this.props.openAndPartialPurchaseOrders}
                                getInventorySummaryForFTL={this.props.getInventorySummaryForFTL}
                                inventorySummaryForFTL={this.props.inventorySummaryForFTL}
                                filteredPackages={this.state.filteredPackages}
                                filteredProducts={this.state.filteredProducts}
                                saveOrderPlanning={this.props.saveOrderPlanning}
                                suppliers={this.props.suppliers}
                                automatePurchaseOrder={this.props.automatePurchaseOrder}
                                listAllOpenAndPartialPurchaseOrders={this.props.listAllOpenAndPartialPurchaseOrders }
                                listAllProductInventory={this.props.listAllProductInventory}
                                listAllBoxInventory={this.props.listAllBoxInventory}
                                refreshNewPurchaseOrder={this.props.refreshNewPurchaseOrder}
                                allShippedFTL={this.props.allShippedFTL}
                                saveFullTruckload={this.props.saveFullTruckload}
                                saveFTLDraft={this.props.saveFTLDraft}
                                listShippedFTLs={this.props.listShippedFTLs}
                            />
                            :
                            <OrderPlanningTable
                                rows={this.props.allOrderPlanning}
                                page={this.state.page}
                                setPage={this.setPage}
                                rowsPerPage={this.state.rowsPerPage}
                                setRowsPerPage={this.setRowsPerPage}
                                handleDoubleClick={this.openOrderPlanning}
                                searchText={this.state.searchText}
                                handleSearchChange={this.handleSearchTextChange}
                                fromLocation={this.state.fromLocation}
                                availableLocations={this.props.availableLocations}
                                deleteOrderPlanning={this.props.deleteOrderPlanning}
                                removePurchaseOrder={this.props.removePurchaseOrder}
                            />

                        :
                        <OrderPlanningForm
                            cancel={this.cancelOrderPlanning}
                            creatingForm={false}
                            fromLocation={this.state.fromLocation}
                            availableLocations={this.props.availableLocations}
                            manufacturers={this.props.manufacturers}
                            productInventory={this.props.productsInventory}
                            boxesInventory={this.props.boxesInventory}
                            openAndPartialPurchaseOrders={this.props.openAndPartialPurchaseOrders}
                            getInventorySummaryForFTL={this.props.getInventorySummaryForFTL}
                            inventorySummaryForFTL={this.props.inventorySummaryForFTL}
                            filteredPackages={this.state.filteredPackages}
                            filteredProducts={this.state.filteredProducts}
                            saveOrderPlanning={this.props.saveOrderPlanning}
                            editOrder={this.state.orderPlanningOpened}
                            suppliers={this.props.suppliers}
                            automatePurchaseOrder={this.props.automatePurchaseOrder}
                            removePurchaseOrder={this.props.removePurchaseOrder}
                            listAllOpenAndPartialPurchaseOrders={this.props.listAllOpenAndPartialPurchaseOrders }
                            listAllProductInventory={this.props.listAllProductInventory}
                            listAllBoxInventory={this.props.listAllBoxInventory}
                            refreshNewPurchaseOrder={this.props.refreshNewPurchaseOrder}
                            allShippedFTL={this.props.allShippedFTL}
                            saveFullTruckload={this.props.saveFullTruckload}
                            saveFTLDraft={this.props.saveFTLDraft}
                            listShippedFTLs={this.props.listShippedFTLs}
                        />
                    }

                </Paper>
            </MuiPickersUtilsProvider>
        );
    }
}

const mapStateToProps = (state) => ({
    user: userInfoSelector(state),
    availableLocations: availableLocationsSelector(state),
    selectedLocation: selectedLocationIdSelector(state),
    manufacturers: manufacturersSelector(state),
    productsInventory: productsInventorySelector(state),
    boxesInventory: boxesInventorySelector(state),
    openAndPartialPurchaseOrders: allOpenAndPartialPurchaseOrdersSelector(state),
    inventorySummaryForFTL: inventorySummaryColumForFTLSelector(state),
    products: productsSelector(state),
    packages: packagesSelector(state),
    allOrderPlanning: allOrderPlanningSelector(state),
    suppliers: realSuppliersSelector(state),
    allShippedFTL: allShippedFTLSelector(state)
});

const actionCreators = {
    listAvailableLocations,
    listManufacturers,
    listAllProductInventory,
    listAllBoxInventory,
    listAllOpenAndPartialPurchaseOrders,
    getInventorySummaryForFTL,
    listProducts,
    listPackages,
    listOrderPlanning,
    saveOrderPlanning,
    deleteOrderPlanning,
    listSuppliers,
    automatePurchaseOrder,
    removePurchaseOrder,
    refreshNewPurchaseOrder,
    listShippedFTLs,
    saveFullTruckload,
    saveFTLDraft

}

export default withShipment({
    mapStateToProps,
    actionCreators
}, OrderPlanning);